@if(loadingService.loading && loadingService.slowConnection && !hideBanner){
<div class="row justify-content-center slow-network-banner">
    <div class="col-12">
        <div class="alert alert-warning py-2">
            Your internet connection seems unstable. This may take some time
        </div>

    </div>
</div>
}
<router-outlet />